import { render, staticRenderFns } from "./GlobalNotification.vue?vue&type=template&id=9d37d992&scoped=true"
import script from "./GlobalNotification.vue?vue&type=script&lang=js"
export * from "./GlobalNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d37d992",
  null
  
)

export default component.exports